import { QuotingPortal } from 'lib/hosts/quoting/interface';
import { Undef } from 'types/UtilityTypes';
import captureException from 'utils/captureException';

export const CarrierPointSubmitAction = 'carrierpoint-submit-quote';

export class CarrierPoint implements QuotingPortal {
  submitAction = CarrierPointSubmitAction;

  canSubmit(tab: Undef<chrome.tabs.Tab>, html: string): boolean {
    if (!tab?.url) return false;

    try {
      const url = new URL(tab.url);
      if (!(
        url.hostname?.toLowerCase().includes('carrierpoint.com') &&
        decodeURIComponent(url.pathname || '')
          .toLowerCase()
          .includes('cpmarketbiddingwindow')
      )) {
        return false;
      }

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const hasForm = doc.querySelector('form#biddingWindowId');
      const hasStopsTable = doc.querySelector(
        '.containerUnsized td.standardtext2 table'
      );

      return Boolean(hasForm && hasStopsTable);
    } catch (error: any) {
      captureException(
        'Error checking CarrierPoint if quote can be submitted:',
        error
      );
      return false;
    }
  }
}
